<template>
  <ThemeDefaultLayoutPage
    :title="asyncCategory?.section.title"
    :description="asyncCategory?.section.description"
    :breadcrumbs="breadcrumbs"
    :categories="asyncCategory?.categoryButtonItems"
    :event-name="eventName"
    :category-event-name="categoryEventName"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <template v-if="articles.length > 0">
      <div
        class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-6"
      >
        <ThemeDefaultCardArticle
          v-for="item in articles"
          :key="`article-${item._id}`"
          title-tag="h2"
          class="tw-h-full"
          :published-at="item.publishedAt || ''"
          :image="item.imageCover || {}"
          :title="item.title || ''"
          :description="item.shortDescription || ''"
          :category-title="item.articleCategory.title || ''"
          :path="getPath({ componentName: 'Article', slug: item.slug })"
          :recommended="item.recommended"
          custom-padding-content="lg:!tw-p-5 !tw-p-5"
          @click="eventArticle(item.title)"
        />
      </div>
      <Pagination v-model="page" :per-page="perPage" :total="total" />
    </template>
    <LandingNoData v-else />
  </ThemeDefaultLayoutPage>
</template>

<script setup lang="ts">
const {
  categoryEventName,
  eventName,
  breadcrumbs,
  asyncCategory,
  articles,
  page,
  perPage,
  total,
  eventArticle,
  getPath,
} = await useArticlePage();
</script>
